import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

const proximityMetricsSelector = (state: AppState) => state.map.mapSettings.data.proximity.metrics;
export const useProximityMetricsSelector = () => useSelector(proximityMetricsSelector);

export const proximitiesSelector = (state: AppState) => state.map.mapSettings.data.proximity.proximities;
export const useProximitiesSelector = () => useSelector(proximitiesSelector);
